module.exports = __webpack_public_path__ + "static/media/points-portal5.b9e65c7e.b9e65c7e.JPG";